<div *ngIf="showProgressbar">
   <div
      *ngIf="userId && (percentUntilAutoChange$ | async) > 0"
      [samwebUserStatusClass]="currentUserStatusInfo$ | async"
      [style.width]="widthForUserStatusChange$ | async"
      class="duration-indicator"
   ></div>
</div>
